// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', {is: require('./_same-value')});


// WEBPACK FOOTER //
// ./~/core-js/modules/es6.object.is.js